import { combineEpics } from "redux-observable";
import alertEpic from "./views/Alert/epics/AlertEpic.js";
import ResolveGateEpics from "./views/ResolveGate/ResolveGate.epics.js";
import ResolveSeedfinderGateEpics from "./views/OverrideGate/OverrideGate.epics.js";
const gateEpics = combineEpics(ResolveGateEpics, ResolveSeedfinderGateEpics);
const AlertEpic = combineEpics(alertEpic);
export {
  ResolveGateEpics,
  ResolveSeedfinderGateEpics,
  alertEpic,
  AlertEpic as default,
  gateEpics
};
//# sourceMappingURL=epics.js.map
